import React, { ReactNode, createContext, useContext } from 'react'
import { useXMPPClientContext } from '../xmpp-client/XMPPClientContext'
import { RoomId, ParsedBlock } from './types'
import { useRoomDataAndEffects } from './useRoomDataAndEffects'

interface Context {
  events: Array<ParsedBlock>
  isInitial: boolean
}

const RoomDataBase = createContext<Context>({
  events: [],
  isInitial: false,
})

const useRoomDataContext = () => {
  return useContext(RoomDataBase)
}
const RoomDataBaseProvider = RoomDataBase.Provider

export { useRoomDataContext }

export const RoomDataProvider = ({
  children,
  isMine,
  roomId,
}: {
  children?: ReactNode
  isMine: boolean
  roomId: RoomId
}) => {
  const { client, publicClient } = useXMPPClientContext()
  const events = isMine ? client.value.events : publicClient.value.events

  const value = useRoomDataAndEffects({
    roomId: roomId,
    events,
    guestId: client.userId,
    botId: 'bot',
    initialEvents: events['initial'],
  })

  return <RoomDataBaseProvider value={value}>{children}</RoomDataBaseProvider>
}
